module.exports = __webpack_public_path__ + "img/TBWTTNL_app_feather_loading.32911c00.jpg";